import { createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-845f0246"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer categoryReName" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layerTitle" }, "My 시리즈에 저장", -1))
const _hoisted_3 = { class: "layerMain" }
const _hoisted_4 = { class: "textinputLine" }
const _hoisted_5 = {
  class: "right",
  style: {"margin-right":"5px"}
}
const _hoisted_6 = { class: "layerBtnArea" }
const _hoisted_7 = {
  class: "layer deletAlt",
  ref: "preview_layer"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layerTitle" }, "미리보기", -1))
const _hoisted_9 = { class: "pageTitleTab mgB15" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "layerMain" }
const _hoisted_12 = { class: "layerBtnArea" }
const _hoisted_13 = { class: "layer deletAlt" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layerTitle" }, "알림", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layerMain" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "layerMainText" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bold red" }, "선택하신 회차를 삭제"),
    /*#__PURE__*/_createTextVNode("하시겠습니까? ")
  ])
], -1))
const _hoisted_16 = { class: "layerBtnArea" }
const _hoisted_17 = { class: "box" }
const _hoisted_18 = { class: "gmFont" }
const _hoisted_19 = {
  class: "box overflow left",
  style: {"width":"calc(100% - 410px)","margin-right":"20px"}
}
const _hoisted_20 = { class: "overflow" }
const _hoisted_21 = { class: "templateBox left" }
const _hoisted_22 = { class: "templateBoxTitle" }
const _hoisted_23 = { class: "gmFont" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "발송", -1))
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["src"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mgT15" }, " ※ 각 회차별 메시지를 클릭하면 발송 시점 및 메시지 내용을 수정하실 수 있습니다. ", -1))
const _hoisted_32 = {
  key: 0,
  class: "conBottom mgT15"
}
const _hoisted_33 = {
  key: 1,
  class: "conBottom mgT15"
}
const _hoisted_34 = {
  class: "box overflow left",
  style: {"width":"310px","position":"relative"}
}
const _hoisted_35 = { class: "selectCutBox adSms mgB15" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bold",
  style: {"font-size":"18px","padding":"3px 0 0","float":"left"}
}, "받는사람", -1))
const _hoisted_37 = { class: "mgB10" }
const _hoisted_38 = { class: "cutBlock" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  class: "pageTitleTab mgB15",
  style: {"width":"100%"}
}
const _hoisted_41 = { class: "mgB15" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" ※ 사용자님의 스마트폰에서 직접 발송한 건은 ‘폰발송 가능 건수’에 포함되지 않습니다. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※ 폰발송을 선택하여 문자 발송을 하실때 사용자님의 핸드폰에 상생레터 앱이 미설치 되어 있거나 앱이 절전모드 상태이면 문자 발송이 되지 않습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※ 폰발송을 선택하여 문자 발송을 하실때 문자무제한 요금제가 아니면 별도의 과금이 부과됩니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※ 1인 1개 핸드폰 앱만 설치 가능합니다. 발신번호가 2개라고 해서 2개 앱을 설치하고 문자 무제한 요금제를 이용하여 '폰발송' 무료 문자를 2배로 사용할 수 있는 것은 아닙니다. ")
], -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "mgB15" }
const _hoisted_45 = { class: "selectBox bold" }
const _hoisted_46 = { class: "blue" }
const _hoisted_47 = { class: "selectBox bold" }
const _hoisted_48 = { class: "red" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "SMS", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "LMS", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "MMS", -1))
const _hoisted_56 = { class: "textCenter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UmsSendPreview = _resolveComponent("UmsSendPreview")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_RecentSendList = _resolveComponent("RecentSendList")!
  const _component_GroupCustSelect = _resolveComponent("GroupCustSelect")!
  const _component_JSDCustSelect = _resolveComponent("JSDCustSelect")!
  const _component_TmplItemEdit = _resolveComponent("TmplItemEdit")!
  const _component_TmplDistLayer = _resolveComponent("TmplDistLayer")!
  const _component_UmsSendLayer = _resolveComponent("UmsSendLayer")!
  const _directive_drt_caret_target = _resolveDirective("drt-caret-target")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "제목을 입력해주세요",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.ui.mytmpl.title) = $event)),
            maxlength: "40",
            style: {"width":"215px"},
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.contUpdate && $options.contUpdate(...args))),
            onCaretUpdate: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.contUpdate && $options.contUpdate(...args)))
          }, null, 544), [
            [_vModelText, $data.ui.mytmpl.title],
            [_directive_drt_caret_target, 'caret']
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString($data.ui.mytmpl.title.koLen()) + "/40", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.myTmplSave()))
        }, "저장"),
        _createTextVNode("  "),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($data.ui.mytmpl.is_view=false))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.ui.mytmpl.is_view]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.tmpl_list, (r) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["tabBtn", {'select' : r.SEQ_NO == $data.ui.preview.seq_no}]),
            onClick: ($event: any) => ($options.preview_set(r.SEQ_NO))
          }, _toDisplayString(r.SEQ_NO) + "회차 ", 11, _hoisted_10))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_UmsSendPreview, {
          ref: "UmsSendPreview",
          title: $data.ui.preview.title,
          message: $data.ui.preview.mesg
        }, null, 8, ["title", "message"]),
        _createTextVNode(" * 이미지는 미리보기에서 확인하실수 없습니다. ")
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => {$data.ui.preview.seq_no=1;$data.ui.preview.is_view=false;})
        }, "닫기")
      ])
    ], 512), [
      [_vShow, $data.ui.preview.is_view]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          class: "redBtn",
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.tmpl_itme_del()))
        }, "삭제"),
        _createTextVNode("  "),
        _createElementVNode("button", {
          class: "grayBtn",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($data.ui.tmpl_del.is_view=false))
        }, "취소")
      ])
    ], 512), [
      [_vShow, $data.ui.tmpl_del.is_view]
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("span", _hoisted_18, _toDisplayString($data.TMPL_NM) + " " + _toDisplayString($data.arr.tmpl_list.length) + "회 발송", 1),
      _createTextVNode("     "),
      _createElementVNode("button", {
        class: "grayBtn mgR10",
        onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.preview_view()))
      }, "미리보기"),
      _createElementVNode("button", {
        class: "grayBtn mgR10",
        onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.tmpl_resv_view()))
      }, "예약발송"),
      ($data.arr.TMPL_TYPE_CD == '99')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "blueBtn",
            onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.myTmplCheck('I')))
          }, " 다른 이름으로 저장(새 시리즈) "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.tmpl_list, (r) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString(r.SEQ_NO) + "회차", 1),
              _createElementVNode("button", {
                class: "right redBtn",
                onClick: ($event: any) => ($options.item_remove(r))
              }, "삭제", 8, _hoisted_24),
              _hoisted_25,
              _hoisted_26,
              _createTextVNode(" : 등록 " + _toDisplayString(r.SEND_TXT) + " 후 " + _toDisplayString(r.CUST_SEND_TM), 1)
            ]),
            _createElementVNode("div", {
              class: "templateBoxMain",
              onClick: ($event: any) => ($options.item_edit(r)),
              style: {"cursor":"pointer"}
            }, [
              (r.IMG_URL.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("img", {
                      style: {"width":"100%","height":"100%","object-fit":"cover","max-width":"none","max-height":"none"},
                      src: $options.renderImg(r.IMG_URL)
                    }, null, 8, _hoisted_29)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                innerHTML: r.CONT.reAll('\n', '<br />')
              }, null, 8, _hoisted_30)
            ], 8, _hoisted_27)
          ]))
        }), 256)),
        _createElementVNode("div", {
          class: "templateBox left msgAdd gmFont",
          onClick: _cache[11] || (_cache[11] = ($event: any) => ($options.item_add()))
        }, " + 새로운 회차 추가 ")
      ]),
      _hoisted_31,
      ($data.arr.TMPL_TYPE_CD != '99')
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("button", {
              class: "blueBtn",
              onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.myTmplCheck('I')))
            }, " 다른 이름으로 저장(새 템플릿) ")
          ]))
        : _createCommentVNode("", true),
      ($data.arr.TMPL_TYPE_CD == '99')
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _createElementVNode("button", {
              class: "blueBtn",
              onClick: _cache[13] || (_cache[13] = ($event: any) => ($options.myTmplCheck('U')))
            }, " 수정사항 저장 "),
            _createTextVNode("  "),
            _createElementVNode("button", {
              class: "blueBtn",
              onClick: _cache[14] || (_cache[14] = ($event: any) => ($options.init()))
            }, " 초기화 ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", null, [
            _hoisted_36,
            _createElementVNode("button", {
              type: "button",
              class: "yellowBtn right",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$refs.recentLayer.show()))
            }, "최근발송"),
            _createElementVNode("button", {
              type: "button",
              class: "whiteBtn right mgR05",
              onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => ($options.group_select && $options.group_select(...args)))
            }, "그룹선택")
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "selectCutNumInput",
              style: {"width":"65%","margin":"0"},
              placeholder: "직접번호입력",
              onInput: _cache[17] || (_cache[17] = (e) => { $data.ui.searchPhone = e.target.value}),
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($data.ui.searchPhone) = $event)),
              onKeyup: _cache[19] || (_cache[19] = _withKeys(($event: any) => ($options.custSearch(true)), ["enter"]))
            }, null, 544), [
              [_vModelText, $data.ui.searchPhone]
            ]),
            _createTextVNode(),
            _createElementVNode("button", {
              class: "whiteBtn right",
              onClick: _cache[20] || (_cache[20] = ($event: any) => ($options.custSearch(true)))
            }, "번호추가")
          ]),
          _createElementVNode("div", _hoisted_37, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              ref: "custSearch",
              class: "selectCutNumInput",
              style: {"width":"65%","margin":"0"},
              placeholder: "이름, 휴대폰 번호 검색",
              onInput: _cache[21] || (_cache[21] = (e) => { $data.ui.searchKey = e.target.value}),
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($data.ui.searchKey) = $event)),
              onKeyup: _cache[23] || (_cache[23] = _withKeys(($event: any) => ($options.custSearch(false)), ["enter"]))
            }, null, 544), [
              [_vModelText, $data.ui.searchKey]
            ]),
            _createTextVNode(),
            _createElementVNode("button", {
              class: "whiteBtn right",
              onClick: _cache[24] || (_cache[24] = ($event: any) => ($options.custSearch(false)))
            }, "번호검색")
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_InfiniteScroll, {
              onInfiniteScroll: _cache[25] || (_cache[25] = ($event: any) => ($options.render(false))),
              loading: _ctx.isLoading
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.arr.render, (r) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createTextVNode(_toDisplayString(`${r.CUST_NM} ${r.PHONE_CNO}`) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "closeBtn right",
                      onClick: ($event: any) => ($options.remove_custs(r))
                    }, "X", 8, _hoisted_39)
                  ]))
                }), 256))
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", {
            class: _normalizeClass(["tabBtn", {'select' : $data.ui.send.is_smt=='1'}]),
            onClick: _cache[26] || (_cache[26] = ($event: any) => {$data.ui.send.is_smt='1';$options.setUms_info()})
          }, "폰발송", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["tabBtn", {'select' : $data.ui.send.is_smt=='0'}]),
            onClick: _cache[27] || (_cache[27] = ($event: any) => {$data.ui.send.is_smt='0';$options.setUms_info()})
          }, "코인발송", 2)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_41, _hoisted_43, 512), [
          [_vShow, $data.ui.send.is_smt=='1']
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("p", _hoisted_45, [
            _createTextVNode("발송 대상 : "),
            _createElementVNode("span", _hoisted_46, _toDisplayString($data.arr.custList.length) + " 명", 1)
          ]),
          _withDirectives(_createElementVNode("p", _hoisted_47, [
            _createTextVNode("코인잔액 : "),
            _createElementVNode("span", _hoisted_48, _toDisplayString($data.ui.send.coin_amt.toComma()), 1)
          ], 512), [
            [_vShow, $data.ui.send.is_smt=='0']
          ]),
          _withDirectives(_createElementVNode("span", null, [
            _createTextVNode(" SMS " + _toDisplayString($data.ui.ums_info.sms_cnt) + "건 * " + _toDisplayString($data.arr.custList.length) + "명 = " + _toDisplayString($data.ui.ums_info.sms_amt.toComma()), 1),
            _hoisted_49
          ], 512), [
            [_vShow, $data.ui.send.is_smt=='0' && $data.ui.ums_info.sms_amt > 0]
          ]),
          _withDirectives(_createElementVNode("span", null, [
            _createTextVNode(" LMS " + _toDisplayString($data.ui.ums_info.lms_cnt) + "건 * " + _toDisplayString($data.arr.custList.length) + "명 = " + _toDisplayString($data.ui.ums_info.lms_amt.toComma()) + " ", 1),
            _hoisted_50
          ], 512), [
            [_vShow, $data.ui.send.is_smt=='0' && $data.ui.ums_info.lms_amt > 0]
          ]),
          _withDirectives(_createElementVNode("span", null, [
            _createTextVNode(" MMS " + _toDisplayString($data.ui.ums_info.mms_cnt) + "건 * " + _toDisplayString($data.arr.custList.length) + "명 = " + _toDisplayString($data.ui.ums_info.mms_amt.toComma()), 1),
            _hoisted_51
          ], 512), [
            [_vShow, $data.ui.send.is_smt=='0' && $data.ui.ums_info.mms_amt > 0]
          ]),
          _withDirectives(_createElementVNode("p", null, [
            _createTextVNode(" ※ 발송요금"),
            _hoisted_52,
            _hoisted_53,
            _createTextVNode(" : " + _toDisplayString($data.ui.send.sms_amt) + "   ", 1),
            _hoisted_54,
            _createTextVNode(" : " + _toDisplayString($data.ui.send.lms_amt) + "   ", 1),
            _hoisted_55,
            _createTextVNode(" : " + _toDisplayString($data.ui.send.mms_amt), 1)
          ], 512), [
            [_vShow, $data.ui.send.is_smt=='0']
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("button", {
            class: "greenBtn mgR10",
            onClick: _cache[28] || (_cache[28] = ($event: any) => ($options.preview_view()))
          }, "미리보기"),
          _createElementVNode("button", {
            class: "grayBtn mgR10",
            onClick: _cache[29] || (_cache[29] = ($event: any) => ($options.tmpl_resv_view()))
          }, "예약발송")
        ]),
        _createVNode(_component_RecentSendList, {
          ref: "recentLayer",
          onSetCustSelect: $options.recentSelect
        }, null, 8, ["onSetCustSelect"])
      ])
    ]),
    _createVNode(_component_GroupCustSelect, {
      ref: "GroupCustSelect",
      onSetCustSelect: $options.setCustSelect
    }, null, 8, ["onSetCustSelect"]),
    _createVNode(_component_JSDCustSelect, {
      ref: "JSDCustSelect",
      search_key: $data.ui.searchKey,
      target: _ctx.$refs.custSearch,
      height: 300,
      is_direct_add: true,
      onSetCustData: $options.setCustData
    }, null, 8, ["search_key", "target", "onSetCustData"]),
    _createVNode(_component_TmplItemEdit, {
      ref: "TmplItemEdit",
      item: $data.tmpl_item,
      onSetItemInfo: $options.setItemInfo
    }, null, 8, ["item", "onSetItemInfo"]),
    _createVNode(_component_TmplDistLayer, {
      ref: "TmplDistLayer",
      cust_cnt: $data.ui.dist_view.cust_cnt,
      send_type: $data.ui.dist_view.send_type,
      tmpl_list: $data.arr.tmpl_list,
      onSetTmplInfo: $options.setTmplInfo
    }, null, 8, ["cust_cnt", "send_type", "tmpl_list", "onSetTmplInfo"]),
    _createVNode(_component_UmsSendLayer, {
      ref: "umsSendLayer",
      custList: $data.arr.custList,
      SEND_CAPA_CNT: 0,
      COIN_BAL_AMT: 0,
      onLayerCallback: _cache[30] || (_cache[30] = () => {})
    }, null, 8, ["custList"])
  ], 64))
}